export default __webpack_public_path__ + "static/media/sliderImg5.c296f196.jpg";